<template>
  <v-container>
    <div v-if="pages">
      <v-btn block outlined color="primary" v-for="(p, i) in pages" :key="i" @click="goToCustomPage(p)">
        {{ p.name }}</v-btn>
    </div>
    <div v-else>
      {{ $t('message.no_custom_apps_at_location') }}
    </div>
  </v-container>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      url: this.$route.query.url,
      height: null,
      pages: null
    };
  },
  created() {

    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy + '/custompages')
      .then(response => {
        const data = response.data;
        if (data && data.pages && data.pages.length > 0) {
          this.pages = data.pages;
        }
      });
  },
  methods: {
    goToCustomPage(p) {
      console.log(p)
      this.navigateTo({ name: 'custompage', query: { url: p.url } });
    }
  }
};
</script>

<style scoped></style>